import { render, staticRenderFns } from "./ContractPaymentPlanPreviewCard.vue?vue&type=template&id=865a84ce&scoped=true&"
import script from "./ContractPaymentPlanPreviewCard.vue?vue&type=script&lang=js&"
export * from "./ContractPaymentPlanPreviewCard.vue?vue&type=script&lang=js&"
import style0 from "./ContractPaymentPlanPreviewCard.vue?vue&type=style&index=0&id=865a84ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "865a84ce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VChip,VCol,VDivider,VIcon,VRow})
